import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { map, catchError, of, mergeMap, takeUntil } from 'rxjs';
import { EventsActions } from '../actions/events.actions';
import { EventsService } from '../service/events.service';
import { Destroy } from '../../common-store/services/destroy.service';

@Injectable()
export class TranslationsEffects {
  loadTranslationsStores$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventsActions.loadEventsListForHorse),
      map((action) => action.horseId),
      mergeMap((horseId) => {
        return this.eventsService.fetchEventsByHorseId(horseId).pipe(
          takeUntil(this.destroy$.destroySubject$),
          map((events) =>
            EventsActions.loadEventsListForHorseSuccess({ events })
          ),
          catchError((error) =>
            of(
              EventsActions.loadEventsListForHorseFailure({
                error: error.message ?? error,
              })
            )
          )
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private eventsService: EventsService,
    private readonly destroy$: Destroy
  ) {}
}
